interface Window {
  analytics: SegmentAnalytics.AnalyticsJS;
}

/**
 * @deprecated The method should not be used directly
 * You should use getSegment instead: https://github.com/project44/micro-webapps#tracking-user-actions-with-segment
 */
export function getAnalytics(): SegmentAnalytics.AnalyticsJS | null {
  return (window as unknown as Window).analytics || null;
}
